import { PaymentLayout } from "Components/Merchant/InitiatePaymentDetail/shared/PaymentLayout";
import { NFCInstructions } from "Components/Merchant/InitiatePaymentDetail/PaymentInProgress/NFCInstructions";
import { QRInstructions } from "Components/Merchant/InitiatePaymentDetail/PaymentInProgress/QRInstructions";
import { TransactionActionButtons } from "Components/Transactions/TransactionActionButtons/TransactionActionButtons";
import type {
  TransactionDetailDto,
  TransactionStatus,
} from "Infrastructure/Api/Api";

type Props = {
  isMerchant: boolean;
  transactionStatus: TransactionStatus;
  transactionsDetail: TransactionDetailDto;
};

export const PaymentInProgressInfo = ({
  isMerchant,
  transactionStatus,
  transactionsDetail,
}: Props) => {
  const { currencyCode, amount, publicID, payPointPublicID } =
    transactionsDetail;
  const isPaypointTransaction = !!payPointPublicID;

  return (
    <PaymentLayout
      amount={amount}
      currencyCode={currencyCode}
      transactionPublicID={publicID}
      transactionStatus={transactionStatus}
      actionsSection={
        <TransactionActionButtons transactionsDetail={transactionsDetail} />
      }
    >
      {isPaypointTransaction ? (
        <NFCInstructions />
      ) : (
        <QRInstructions isMerchant={isMerchant} />
      )}
    </PaymentLayout>
  );
};
